import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const ActionPanelMenuLayout = styled(Box, {
  name: 'ActionPanelMenuLayout',
  slot: 'Root',
  overridesResolver: (_props, styles) => [styles.root],
})({});
